// api/user.js
import request from "@/utils/request.js"

// 全局设计 信息
export function globalInformation() {
    return request({
        url: `/getGroup`,
        method: "get",
    })
}
